/*
PURPOSE: Single source for the Coral Tickets app URL (stage-aware).
USE CASES:
- The community-platform header and footer link out to Coral Tickets.
DOMAIN BOUNDARIES:
- URL construction only. No fetch, no auth.
ASSUMPTIONS:
- Stage comes from REACT_APP_ENVIRONMENT (defaults to 'dev'). Naming is
  stage-first, matching the tickets subdomain's own convention: dev/staging
  carry the stage prefix, prod drops it (dev.tickets.wearecoral.org /
  stg.tickets.wearecoral.org / tickets.wearecoral.org).
*/

const ticketsStage = (): string => process.env.REACT_APP_ENVIRONMENT || 'dev';

export const getTicketsUrl = (): string => {
  const stage = ticketsStage();
  return stage === 'prod' ? 'https://tickets.wearecoral.org' : `https://${stage}.tickets.wearecoral.org`;
};
